import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Card,
  LinkButton,
  PageTitle,
} from '@foxtrotplatform/developer-platform-common-ui-component-lib';
import React from 'react';

import {
  BuiltInApiInformation,
  GetBuiltInApiInformation,
} from '../../common/api/built-in-apis';

export const BuiltInApis: React.FunctionComponent = () => {
  const [builtInApis, setBuiltInApis] =
    React.useState<BuiltInApiInformation[]>();

  React.useEffect(() => {
    const getApiInformation = async () => {
      const apiInformation = await GetBuiltInApiInformation();

      if (apiInformation) {
        setBuiltInApis(apiInformation);
      }
    };
    getApiInformation();
  }, []);

  return (
    <div className="bg-gradient-to-b from-gray-100 p-os1-spacing">
      <div className="flex flex-row justify-between w-full mb-5">
        <PageTitle>Explore our tailor-built logistics APIs</PageTitle>
        <LinkButton
          linkText="Learn more"
          onClick={() => window.open('https://docs.getos1.com')}
        />
      </div>
      <div className="flex flex-wrap justify-between gap-y-4 h-full">
        {builtInApis?.map(({ icon, description, linkUrl, linkText }, index) => {
          return (
            <Card
              className="flex flex-row w-92 py-3 justify-start bg-white"
              key={`${linkText}_${index}`}
            >
              <div>
                <FontAwesomeIcon
                  className="fa-lg pl-4 pt-1 pr-3.5"
                  icon={icon}
                />
              </div>
              <div className="flex flex-col justify-start items-start">
                <LinkButton
                  className="text-xs"
                  linkText={linkText}
                  onClick={() => window.open(linkUrl)}
                />
                <span className="text-sm">{description}</span>
              </div>
            </Card>
          );
        })}
      </div>
    </div>
  );
};
